import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  gridContainer: {
    height: '100%',
    maxWidth: '1080px',
    margin: '0 auto',

    '& .notifications': {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      maxWidth: 1080,
      padding: '20px 30px 0px',
      width: '100%',
      '& > :last-child': {
        marginBottom: '20px',
      },
      [Theme.breakpoints.up('md')]: {
        padding: '30px 30px 0px',
      },
    },
  },
  confirmationContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0',
    width: '100%',
    maxWidth: '1080px',
    fontFamily: Theme.typography.base.regular,
    padding: '0px 20px',
    paddingBottom: '40px',
    [Theme.breakpoints.up('md')]: {
      padding: '0px 30px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '0px 0px',
    },
    '& .MuiTypography-subtitle1': {
      margin: '24px 0 16px',
    },
  },
  confirmationHeader: {
    paddingBottom: '40px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[9],
    },
  },
  confirmationTitle: {
    fontSize: Theme.typography.size[6],
    lineHeight: '120%',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[8],
    },
    [Theme.breakpoints.up('xl')]: {
      fontSize: Theme.typography.size[9],
    },
  },
  confirmationSubtitle: {
    paddingTop: '10px',
    fontSize: Theme.typography.size[2],
    lineHeight: '120%',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.regular,
    textAlign: 'center',
    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.size[3],
    },
  },

  faqLink: {
    display: 'inline',
  },
  faqMessage: {
    fontSize: Theme.typography.size[6],
    lineHeight: '120%',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.regular,
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[7],
    },
  },
  printButton: {
    margin: 0,
    marginLeft: '10px',
    fontSize: '14px',
    lineHeight: '150%',
  },
  checkIcon: {
    height: '45px',
    width: '45px',
    color: Theme.palette.green,
    marginBottom: '25px',
    [Theme.breakpoints.up('sm')]: {
      height: '45px',
      width: '45px',
    },
  },
  confirmationDescription: {
    fontSize: '18px',
    lineHeight: '150%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',

    '& p': {
      color: Theme.palette.primary.main,
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[2],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[1],
      },
      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[2],
      },
    },
  },
  confirmationNumber: {
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.gray[750],
    fontSize: 16,
    lineHeight: '150%',
    [Theme.breakpoints.up('lg')]: {
      fontSize: '16px',
    },
    [Theme.breakpoints.up('xl')]: {
      fontSize: '18px',
    },

    '& span': {
      display: 'block',
    },
  },
  confirmationEmailContainer: {
    marginBottom: 24,
    fontSize: Theme.typography.size[3],
  },

  confirmationCta: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingTop: 24,
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: 24,
    },
  },
  confirmationReviewCard: {
    paddingTop: '4px',
    '& .cardHeader': {
      marginTop: '',
    },
  },

  heroPicture: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    minHeight: '300px',
    [Theme.breakpoints.down('lg')]: {
      minHeight: '280px',
    },
    [Theme.breakpoints.down('md')]: {
      minHeight: '215px',
    },
    '& img': {
      width: '100%',
      height: '100%',
      position: 'absolute',
    },
  },

  heroContent: {
    zIndex: 1,
    padding: '10px 70px',

    '& h1': {
      fontFamily: Theme.typography.display.regular,
      fontSize: Theme.typography.size[13],
      lineHeight: Theme.typography.size[13],
      color: Theme.palette.white,
      textTransform: 'uppercase',
      textAlign: 'center',
      [Theme.breakpoints.down('lg')]: {
        fontSize: Theme.typography.size[12],
        lineHeight: Theme.typography.size[12],
      },
      [Theme.breakpoints.down('md')]: {
        fontSize: Theme.typography.size[11],
        lineHeight: Theme.typography.size[11],
      },
    },
  },
  divider: {
    marginBottom: 30,
    marginTop: 30,
    [Theme.breakpoints.down('sm')]: {
      marginBottom: 20,
      marginTop: 20,
    },
  },
  transportation: {
    color: Theme.palette.gray[750],
    display: 'flex',

    '& .MuiCardContent-root': {
      padding: 24,
      [Theme.breakpoints.up('lg')]: {
        paddingRight: 40,
      },
    },

    '& p': {
      fontFamily: Theme.typography.base.regular,

      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& p:nth-child(1), p:nth-child(2)': {
      textTransform: 'uppercase',
      color: Theme.palette.primary.main,
      marginBottom: 8,
      lineHeight: 'normal',
    },
    '& p:nth-child(1)': {
      fontSize: Theme.typography.size[3],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[5],
      },
    },
    '& p:nth-child(2)': {
      color: Theme.palette.primary.main,
      fontFamily: Theme.typography.display.regular,
      fontSize: Theme.typography.size[10],
      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[11],
      },
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[12],
      },
    },
    '& p a': {
      fontFamily: Theme.typography.base.semiBold,
      display: 'inline',
      margin: 0,
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[3],
      },
    },
    '& a': {
      margin: 0,
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.primary.light,
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& img': {
      display: 'none',

      [Theme.breakpoints.up('sm')]: {
        display: 'inline-block',
        width: 281,
        objectFit: 'cover',
      },
      [Theme.breakpoints.up('lg')]: {
        width: 336,
      },
      [Theme.breakpoints.up('xl')]: {
        width: 476,
      },
    },
  },

  banner: {
    marginBottom: 24,
    marginLeft: '-20px',
    marginRight: '-20px',
    marginTop: '-30px',
    color: Theme.palette.grey1,
    fontSize: Theme.typography.size[1],
    [Theme.breakpoints.up('md')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
    },

    '& >div:nth-child(1) >div:nth-child(1)': {
      minWidth: 62,
    },
  },
}));

export default useStyles;
